import * as React from "react";
import PropTypes from 'prop-types';

const SvgClose = props => {
  if (props.id !== "_svgclose") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 32 32" {...props}><path d="M15.693 12.893l8-8a2.255 2.255 0 013.2-.387 2.267 2.267 0 01-.36 3.174l-8 8 8 8a2.266 2.266 0 01.36 3.173 2.266 2.266 0 01-3.173-.36l-8-8-8 8a2.266 2.266 0 01-3.173.36 2.253 2.253 0 01.36-3.173l8-8-8-8a2.252 2.252 0 01-.401-3.173 2.253 2.253 0 013.174.36l8.013 8.026z" /></svg>;
};

SvgClose.displayName = "_svgclose";
SvgClose.propTypes = {
  id: PropTypes.string
};
SvgClose.defaultProps = {
  id: ''
};
export default SvgClose;